import http from '../http'

export default {
  async list() {
    const { data } = await http.get('/api/private/v1/application')
    return data.data
  }
}
